// The top-right column: the turn row and the objectives under it.

import { styled } from "../kit";
import { ObjectivePanel } from "../ObjectivePanel";
import type { WatchTransport } from "../useWatchTransport";
import type { BoardInteraction } from "../useBoardInteraction";
import { TurnRowZone } from "./TurnRowZone";

/**
 * Anchored at its own corner and sized by its contents, which is the whole
 * floating-layout argument (PLAN-UI §28.3) — nothing in it can reflow anything,
 * and each piece registers what it covers with the inset registry itself.
 * There is no dock to step aside for, so the corner is the screen's own.
 */
const Column = styled("div")(({ theme }) => ({
  position: "absolute",
  right: 14,
  top: 12,
  zIndex: theme.kit.z.chrome,
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-end",
  gap: 9
}));

export function TopRight({
  board_,
  watch,
  onPause
}: {
  board_: BoardInteraction;
  watch: WatchTransport;
  onPause: () => void;
}) {
  return (
    <Column>
      <TurnRowZone board_={board_} watch={watch} onPause={onPause} />
      {/* Under the turn row, in the column with it — it no longer dodges a
          dock, so it simply stacks. */}
      <ObjectivePanel />
    </Column>
  );
}
